var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoldAlphabet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7 11.0925C15.4275 10.59 15.9375 9.765 15.9375 9C15.9375 7.305 14.625 6 12.9375 6H8.25V16.5H13.53C15.0975 16.5 16.3125 15.225 16.3125 13.6575C16.3125 12.5175 15.6675 11.5425 14.7 11.0925ZM10.5 7.875H12.75C13.3725 7.875 13.875 8.3775 13.875 9C13.875 9.6225 13.3725 10.125 12.75 10.125H10.5V7.875ZM13.125 14.625H10.5V12.375H13.125C13.7475 12.375 14.25 12.8775 14.25 13.5C14.25 14.1225 13.7475 14.625 13.125 14.625Z",
    fill: "#8897AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldAlphabet);
export default __webpack_public_path__ + "static/media/bold-alphabet.804c617fd000dc29ea44695fa4a9b0c9.svg";
export { ForwardRef as ReactComponent };